// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* chart.css */

.chart-container {
    display: flex;
    justify-content: center;
    font-size: 0.75rem; /* equivalent to text-xs */
  }
  
  .tooltip-container {
    padding: 0.5rem;
    background-color: white;
    border: 1px solid #e2e8f0; /* equivalent to border-gray-200 */
  }
  
  .font-medium {
    font-weight: 500; /* This is the equivalent of Tailwind's font-medium */
  }`, "",{"version":3,"sources":["webpack://./src/assets/styles/chart.css"],"names":[],"mappings":"AAAA,cAAc;;AAEd;IACI,aAAa;IACb,uBAAuB;IACvB,kBAAkB,EAAE,0BAA0B;EAChD;;EAEA;IACE,eAAe;IACf,uBAAuB;IACvB,yBAAyB,EAAE,kCAAkC;EAC/D;;EAEA;IACE,gBAAgB,EAAE,qDAAqD;EACzE","sourcesContent":["/* chart.css */\n\n.chart-container {\n    display: flex;\n    justify-content: center;\n    font-size: 0.75rem; /* equivalent to text-xs */\n  }\n  \n  .tooltip-container {\n    padding: 0.5rem;\n    background-color: white;\n    border: 1px solid #e2e8f0; /* equivalent to border-gray-200 */\n  }\n  \n  .font-medium {\n    font-weight: 500; /* This is the equivalent of Tailwind's font-medium */\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
